// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__3Mxy6"};